import { useMemo } from 'react';

import type { PrimaryFilterId } from '../../filters/types/filters';
import {
  MultiMetricProvider,
  type MultiMetricProviderResult,
} from './MultiMetricProvider';
import type { DataProviderChildren } from './types';
import { extractMetricsWithChartTypes } from './utils/text-metrics';

type TextMultiMetricProviderProps = {
  primaryDimension?: PrimaryFilterId;
  text: string;
  children: DataProviderChildren<MultiMetricProviderResult>;
};

export const TextMultiMetricProvider = ({
  primaryDimension,
  text,
  children,
}: TextMultiMetricProviderProps) => {
  const { metrics, metricChartTypes } = useMemo(
    () => extractMetricsWithChartTypes([text]),
    [text]
  );

  return (
    <MultiMetricProvider
      primaryDimension={primaryDimension}
      metrics={metrics}
      chartType="text"
      metricChartTypes={
        Object.keys(metricChartTypes).length ? metricChartTypes : undefined
      }
    >
      {children}
    </MultiMetricProvider>
  );
};
